import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-python-page',
  templateUrl: './python-page.component.html',
  styleUrls: ['./python-page.component.scss']
})
export class PythonPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
